import {createRouter, createWebHistory} from "vue-router";
import {store} from '@/store'

import DashboardLayout from "@/views/Layout/DashboardLayout";

// Dashboard pages
import Dashboard from "../views/Dashboard/Dashboard.vue";

//Topdesk pages
import Incident from "@/views//Pages/Topdesk/Incident";
import Incidents from "@/views/Pages/Topdesk/Incidents";
import Assets from "@/views/Pages/Topdesk/Assets";
import Statistics from "@/views/Pages/Topdesk/Statistics";

//Abacus pages
import Invoices from "@/views/Pages/Abacus/Invoices";
import Contracts from "@/views/Pages/Abacus/Contracts";
import Services from "@/views/Pages/Abacus/Services";
import Contacts from "@/views/Pages/Abacus/Contacts";
import Employees from "@/views/Pages/Abacus/Employees";
import Customers from "@/views/Pages/Abacus/Customers";
import Customer from "@/views/Pages/Abacus/Customer";

//Keycloak pages
import Users from "@/views/Pages/Users/Users";

//RIO pages
import Groups from "@/views/Pages/RIO/Groups";
import Licenses from "@/views/Pages/RIO/Licenses";
import RIONews from "@/views/Pages/RIO/RIONews";
import Forms from "@/views/Pages/RIO/Forms";

//Various
import Downloads from "@/views/Pages/Various/Downloads";
import Help from "@/views/Pages/Support/Help";
import DataProtection from "@/views/Pages/Support/DataProtection";

//Admin
import MailTemplates from "@/views/Pages/Admin/MailTemplates";

const routes = [
    {
        path: "/",
        redirect: "/dashboard",
        component: DashboardLayout,
        name: "Dashboards",
        children: [
            {
                path: "/dashboard",
                name: "Dashboard",
                components: {default: Dashboard},
            },
        ]
    },
    {
        path: "/servicedesk",
        redirect: "/incidents",
        component: DashboardLayout,
        name: "Servicedesk",
        children: [
            {
                path: '/incidents',
                name: 'Incidents',
                components: {default: Incidents},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/incidents/:id',
                name: 'Incident',
                components: {default: Incident},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/assets',
                name: 'Assets',
                components: {default: Assets},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/stats',
                name: 'Statistiken',
                components: {default: Statistics},
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: "/abacus",
        redirect: "/invoices",
        component: DashboardLayout,
        name: "CRM",
        children: [
            {
                path: "/invoices",
                name: "Rechnungen",
                components: {default: Invoices},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/contracts",
                name: "Verträge",
                components: {default: Contracts},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/services",
                name: "Leistungen",
                components: {default: Services},
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: "/rionet",
        redirect: "/licenses",
        component: DashboardLayout,
        name: "RIONet",
        children: [
            {
                path: "/licenses",
                name: "Lizenzen",
                components: {default: Licenses},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/rionews",
                name: "News",
                components: {default: RIONews},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/forms",
                name: "Formulare",
                components: {default: Forms},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/groups",
                name: "Gruppen",
                components: {default: Groups},
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: "/various",
        redirect: "/downloads",
        component: DashboardLayout,
        name: "Various",
        children: [
            {
                path: "/downloads",
                name: "Downloads",
                components: {default: Downloads},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/help",
                name: "Help",
                components: {default: Help},
            },
            {
                path: "/data-protection",
                name: "DataProtection",
                components: {default: DataProtection},
            },
        ]
    },
    {
        path: "/support",
        redirect: "/data-protection",
        component: DashboardLayout,
        name: "Support",
        children: [
            {
                path: "/data-protection",
                name: "DataProtection",
                components: {default: DataProtection},
            },
        ]
    },
    {
        path: "/admin",
        redirect: "/templates",
        component: DashboardLayout,
        name: "Templates",
        children: [
            {
                path: "/templates",
                name: "Templates",
                components: {default: MailTemplates},
            },
        ]
    },
    {
        path: "/allgemein",
        redirect: "/contacts",
        component: DashboardLayout,
        name: "Allgemein",
        children: [
            {
                path: "/contacts",
                name: "Kontakte",
                components: {default: Contacts},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/employees",
                name: "Mitarbeiter",
                components: {default: Employees},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/customers",
                name: "Kunden",
                components: {default: Customers},
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/customers/:id",
                name: "Kunde",
                components: {default: Customer},
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: "/admin",
        redirect: "/users",
        component: DashboardLayout,
        name: "Admin",
        children: [
            {
                path: "/users",
                name: "Benutzer",
                components: {default: Users},
                meta: {
                    requiresAuth: true
                }
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    mode: "history",
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        localStorage.setItem('loginRedirect', to.path);
        if (store.state.auth.user) {
            next()
        } else {
            router.push('/');
        }
    } else {
        localStorage.setItem('loginRedirect', to.path);
        next()
    }
})

export default router;

